import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';

import Select from 'react-select';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import history from 'config/history';
import { buildUrlFromNextRedirect } from 'shared/utils/buildUrlFromNext';

import { DASHBOARD_URL, MODALS } from 'global-constants';
import Button from 'shared/components/Button';
import { openModal } from 'shared/components/Modals/reducer';
import BackStep from 'shared/components/BackStep';
import CountrySelectOption from 'shared/components/CountrySelectOption';
import {
  fetchCountries,
  patchUserCountry,
  previousStep,
  nextStep
} from 'shared/components/Signup/ducks';
import { getFinalStepText } from 'shared/components/Signup/utils';

import styles from './styles.module.scss';

class ChooseCountry extends Component {
  state = {
    selectedCountry: null
  };

  componentDidMount() {
    this.props.fetchCountries();
  }

  nextStep = () => {
    const data = _.map(this.state.selectedCountries, country => {
      return country.value;
    });
    this.props.nextStep({ countries: data });
  };

  handleChange = selectedOption => {
    this.setState({ selectedCountry: selectedOption });
  };

  isLastStep = () => {
    const { currentStep, steps } = this.props;

    if (_.isEqual(currentStep, _.last(steps))) return true;
    return false;
  };

  closeActions = () => {
    this.props.closeModal();
    const nextURL = buildUrlFromNextRedirect(history.location.search);

    if (nextURL) {
      this.props.push(nextURL);
      return;
    }

    this.props.push(DASHBOARD_URL);
    this.props.openModal({ modalName: MODALS.POST_SIGNUP });
  };

  nextStep = () => {
    this.props.patchUserCountry({
      country: this.state.selectedCountry.value
    });

    // this.props.nextStep();
  };

  render() {
    const { countries, patchUserCountry, previousStep } = this.props;
    const { selectedCountry } = this.state;
    const options = _.map(countries, country => {
      return { label: country.name, value: country.id, flag: country.flag };
    });

    const isLastStep = this.isLastStep();

    const finalStepText = getFinalStepText({
      defaultText: 'Continue to Dashboard'
    });

    return (
      <div className={styles.countrySelectWrapper}>
        <div>
          <BackStep onClickEvent={previousStep} />
          <div className={classnames('secondary-page-title', styles.pageTitle)}>
            {isLastStep && <span>Last step - </span>}Where are you based?
          </div>
          <div className={styles.inputWrapper}>
            <Select
              value={selectedCountry}
              onChange={this.handleChange}
              isMulti={false}
              options={options}
              components={{ Option: CountrySelectOption }}
            />
          </div>
        </div>
        <div className={styles.btnAndSkipStepWrapper}>
          {isLastStep && (
            <Button
              className={styles.completeProfileBtn}
              color="primary"
              onClick={() => {
                if (!_.isNil(selectedCountry))
                  patchUserCountry({
                    country: selectedCountry.value
                  });
                this.closeActions();
              }}>
              {finalStepText}
            </Button>
          )}
          {!isLastStep && (
            <Button
              color="primary"
              className={styles.completeProfileBtn}
              disabled={_.isNil(this.state.selectedCountry)}
              onClick={this.nextStep}>
              Next Step
            </Button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { steps, currentStep } = state.signup;
  return {
    countries: state.signup.countries,
    steps,
    currentStep
  };
};

const mapDispatchToProps = {
  fetchCountries,
  patchUserCountry,
  previousStep,
  push,
  openModal,
  nextStep
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChooseCountry);
